/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.array.concat.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getProductList, addshoppingCart } from '@/api';
export default {
  name: 'classificationList',
  data: function data() {
    return {
      classificationData: [],
      id: this.$route.params.id,
      loading: false,
      finished: false,
      isUpLoading: false,
      // 上拉加载
      upFinished: false,
      // 上拉加载完毕
      offset: 100,
      // 滚动
      seachForm: {
        keyword: '',
        fk_t_shop_classification_id: this.$route.params.id,
        pageIndex: 0,
        pageSize: 10
      }
    };
  },
  methods: {
    onLoad: function onLoad() {
      var _this = this;
      setTimeout(function () {
        getProductList(_objectSpread({}, _this.seachForm)).then(function (res) {
          if (res.success) {
            if (res.data == null || res.data.length < 1) {
              _this.upFinished = true; // 加载结束
              return;
            }
            if (res.data.length < _this.seachForm.pageSize) {
              _this.upFinished = true; // 最后一页不足10条的情况
            }
            if (_this.seachForm.pageIndex === 0) {
              _this.classificationData = res.data;
            } else {
              _this.classificationData = _this.classificationData.concat(res.data);
            }
          }
        });
        _this.loading = false;
      }, 1000);
    },
    addCar: function addCar(item) {
      var _this2 = this;
      var data = {
        fk_t_shop_product_id: item.fk_t_shop_goods_id,
        add_munber: 1
      };
      addshoppingCart(data).then(function (res) {
        if (res.success) {
          _this2.$vux.toast.text(i18n.tc("636"));
        } else {
          _this2.$vux.toast.text(i18n.tc("637"));
        }
      });
    },
    productDetails: function productDetails(item) {
      this.$router.push("/serviceMall/classification/classificationList/".concat(item.fk_t_shop_goods_id));
    },
    onRefresh: function onRefresh() {
      this.onLoad();
      this.$vux.toast.text(i18n.tc("641"));
    },
    onLoadList: function onLoadList() {
      this.seachForm.pageIndex++;
      this.onLoad();
    }
  },
  created: function created() {
    this.onLoad();
  }
};